import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CreateProductComponent } from './create-product/create-product.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { ImportProductComponent } from './import-product/import-product.component';
import { ProductService } from '../services/product.service';
import { CategoryService } from '../services/category.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
})
export class ProductComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: CreateProductComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditProductComponent;
  @ViewChild('pImport', { static: false }) pImport: ImportProductComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  listCategory: { label: string; value: string }[] = [];
  categoryId: any = '';

  constructor(
    private router: Router,
    private _service: ProductService,
    private _categoryService: CategoryService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
      categoryId: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'code',
        header: 'Mã sản phẩm',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'name',
        header: 'Tên sản phẩm',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'categoryName',
        header: 'Dịch vụ',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
    this.getListCategory();
  }

  getListCategory() {
    this._categoryService.getListCategory({status: 1}).then(
      (res) => {
        this.listCategory = res?.data.map((x) => ({
          label: `${x.code} - ${x.name}`,
          value: x.id,
        }));
        this.listCategory.unshift({ label: 'Chọn tất cả', value: '' });
      },
      (err) => {
        this.listCategory = [];
      }
    );
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      search: this.code ?? '',
      categoryId: this.categoryId,
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize,
    };

    this._service
      .getListProduct(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editProduct(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }
  deleteProduct(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động sản phẩm này')
        .then((res) => {
          if (res) {
            // this._service.delete(item.identifier).then(
            //   () => {
            //     this._notifierService.showDeleteDataSuccess();
            //     this.getData();
            //   },
            //   () => {
            //     this._notifierService.showDeleteDataError();
            //   }
            // );
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }

  onAdd() {
    this.pCreate.showPopup();
  }

  onImport() {
    this.pImport.showPopup();
  }
  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
